import { HANDOVER_CHECKLIST, GATE_INFO,GATE_DETAIL } from "./type";

const initalState = {
  handOverData: {},
  gateInfo: {},
  gateDetail: {},
};

const handOverReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case HANDOVER_CHECKLIST:
      return {
        ...state,
        handOverData: payload,
      };
    case GATE_INFO:
      return {
        ...state,
        gateInfo: payload,
      };
      case GATE_DETAIL:
      return {
        ...state,
        gateDetail: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default handOverReducer;
